
import { LocationModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { locationsStore } from '@/libs/locations/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import LocationDialog from '../components/LocationDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        LocationDialog,
    },
})
export default class Locations extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('locations.code'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('locations.name'), value: 'name', align: 'left', sortable: false },
            { text: this.$i18n.t('locations.canPlanShifts'), value: 'canPlanShifts', align: 'left', sortable: false },
            { text: this.$i18n.t('locations.parental'), value: 'id', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: LocationDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return locationsStore.useGetter(CrudGetter.Pending);
    }

    get locations(): LocationModel[] {
        return [...locationsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...locationsStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        locationsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<LocationModel>({ field: 'name', index: 1, order: 'asc' }, this.getFilters());
    }

    open(item: LocationModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }

    getParentalLocationById(id: string | null): LocationModel | undefined {
        return this.locations.find((x) => x.id == id);
    }
}
